import React, { FC, useEffect, useRef, useState } from "react";
import ICImage from "../../core-component/ICImage";
import { Link, useNavigate } from "react-router-dom";
import { publicRoute } from "../../routes/RoutePublic";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  cancelIcon,
  cancelPublicIcon,
  menu,
} from "../../assets/icons/SvgIconList";
import { PUBLIC_HEADER_TABS, USER_ROLE } from "../../utils/AppEnumerations";
import { localStorageUtils } from "../../utils/LocalStorageUtil";
import { userRoute } from "../../routes/RouteUser";
import { routeTrainer } from "../../routes/RouteTrainer";
interface IPublicHeaderProp {
  hasScrolled?: boolean;
  activeTab?: string;
  scrollContainerRef?: React.RefObject<HTMLDivElement>;
}
const HomePublicHeader: FC<IPublicHeaderProp> = ({
  hasScrolled,
  activeTab = "home",
  scrollContainerRef,
}) => {
  const { t } = UseTranslationHook();
  const navigate = useNavigate();
  const [isActive, setActive] = useState(false);
  const token = localStorageUtils.getAccessToken();
  const profileImage = localStorageUtils.getProfileUrl();
  const role = localStorageUtils.getRole();
  const handleNavigation = (section: string) => {
    const options = section ? { state: { section } } : undefined;
    navigate(publicRoute.home, options);
  };
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (scrollContainerRef) {
      const handleScroll = () => {
        if (
          scrollContainerRef.current &&
          scrollContainerRef.current.scrollTop > 0
        ) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      };

      if (scrollContainerRef.current) {
        scrollContainerRef.current.addEventListener("scroll", handleScroll);
      }

      return () => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.removeEventListener(
            "scroll",
            handleScroll
          );
        }
      };
    }
  }, [scrollContainerRef]);
  return (
    <div
      className={`fixed w-full z-[800] ${
        isScrolled ? "bg-skin-home-bg" : "bg-transparent shadow-md"
      }`}
    >
      {!isActive && (
        <>
          <div
            className={`flex ${
              !isScrolled && `justify-end`
            } mb-2 text-skin-insights text-xl h-24 items-center w-full p-2 xl:px-16 px-5`}
          >
            {isScrolled ? (
              <div className="w-full flex justify-center">
                <Link to={publicRoute.home}>
                  <ICImage
                    height={87}
                    width={220}
                    src={require("../../assets/image/vp-logo-square.png")}
                    scaled={false}
                  />
                </Link>
              </div>
            ) : (
              ""
            )}
            <div className="nav-mobile-public">
              <div className="flex justify-end" onClick={() => setActive(true)}>
                <div className="h-7 w-7 cursor-pointer">{menu}</div>
              </div>
            </div>
          </div>
        </>
      )}
      {isActive && (
        <div className="transition-all bg-skin-home-bg  duration-300 h-screen overflow-y-scroll">
          <div className="w-full flex justify-end">
            <div
              className="h-6 w-6 m-5 cursor-pointer relative"
              onClick={() => setActive(false)}
            >
              {cancelIcon}
            </div>
          </div>
          <div>
            <div className="flex self-center  items-center justify-center text-skin-insights w-full ">
              <div className="flex justify-between tracking-widest flex-col lg:w-[30%] w-full">
                <div className={`m-3`}>
                  <Link
                    to={`${publicRoute.home}`}
                    className={`p-4 flex justify-center rounded-lg transition-all duration-500 hover:bg-skin-insights-card ${
                      activeTab === PUBLIC_HEADER_TABS.Home
                        ? "bg-skin-home-slide text-black"
                        : ""
                    }`}
                  >
                    {t("home")}
                  </Link>
                </div>
                <div className="m-3">
                  <Link
                    to={`/${publicRoute.offerings}`}
                    className={`p-4 flex justify-center rounded-lg transition-all duration-500 hover:bg-skin-insights-card ${
                      activeTab === PUBLIC_HEADER_TABS.Offerings
                        ? "bg-skin-home-slide text-black"
                        : ""
                    }`}
                  >
                    {t("offerings")}
                  </Link>
                </div>
                <div className="m-3">
                  <Link
                    to={`/${publicRoute.insights}`}
                    className={`p-4 flex justify-center rounded-lg transition-all duration-500 hover:bg-skin-insights-card ${
                      activeTab === PUBLIC_HEADER_TABS.Insights
                        ? "bg-skin-home-slide text-black"
                        : ""
                    }`}
                  >
                    {t("insights")}
                  </Link>
                </div>
                <div className="m-3">
                  <Link
                    to={`/${publicRoute.events}`}
                    className={`p-4 flex justify-center rounded-lg transition-all duration-500 hover:bg-skin-insights-card ${
                      activeTab === PUBLIC_HEADER_TABS.Events
                        ? "bg-skin-home-slide text-black"
                        : ""
                    }`}
                  >
                    {t("events")}
                  </Link>
                </div>
                {/* <div className="m-3">
                                    <Link
                                        to={`/${publicRoute.aboutUs}`}
                                        className={`p-4 flex justify-center rounded-lg transition-all duration-500 hover:bg-skin-insights-card ${activeTab === PUBLIC_HEADER_TABS.AboutUs
                                            ? "bg-skin-home-slide text-black"
                                            : ""
                                            }`}
                                    >
                                        {t("get_to_know_us")}
                                    </Link>
                                </div> */}
                <div className="m-3">
                  <Link
                    to={`/${publicRoute.contactUs}`}
                    className={`p-4 flex justify-center rounded-lg transition-all duration-500 hover:bg-skin-insights-card ${
                      activeTab === PUBLIC_HEADER_TABS.ContactUs
                        ? "bg-skin-home-slide text-black"
                        : ""
                    }`}
                  >
                    {t("get_in_touch")}
                  </Link>
                </div>
                <div className={`m-3 animated-bg p-4 rounded-lg`}>
                  <Link
                    to="https://docs.google.com/forms/d/1ZgdAq_GOwZY2SQAtFUuX14DxEIhJKEZZYOmxFZqxThw/edit"
                    target="_blank"
                    className="transition-all flex justify-center  duration-500"
                  >
                    {t("take_survey")}
                  </Link>
                </div>
                {/* <div className="m-3">
                  <div
                    className={`p-4 flex justify-center border-2 border-white cursor-pointer rounded-lg transition-all duration-500 hover:bg-skin-insights-card`}
                    onClick={() => handleNavigation("h-footer")}
                  >
                    {t("get_notified")}
                  </div>
                </div> */}
                <div className="flex justify-center h-16 items-center mt-5 p-4">
                  {token ? (
                    <div
                      className="cursor-pointer sign-in-button hover:bg-skin-home-bg text-center flex items-center justify-center p-6 w-full  h-full rounded-lg"
                      onClick={() =>
                        navigate(
                          Number(role) === USER_ROLE.Customer
                            ? userRoute.home
                            : routeTrainer.trainerHome
                        )
                      }
                    >
                      {t("my_account")}
                    </div>
                  ) : (
                    <div
                      onClick={() => navigate(publicRoute.welcome)}
                      className="cursor-pointer sign-in-button hover:bg-skin-home-bg text-center flex items-center justify-center p-6 lg:w-[30%] w-full  h-full rounded-lg"
                    >
                      {t("sign_in")}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isScrolled && <hr className="!text-[#333333]" />}
    </div>
  );
};

export default HomePublicHeader;
